/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_Error_BodyInputs */

const en_portalnotify_error_body = /** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your connection, then try again.`)
};

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const ar_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const he_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const ur_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const es_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const fr_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const de_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const pt_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const hi_portalnotify_error_body = en_portalnotify_error_body;

/** @type {(inputs: Portalnotify_Error_BodyInputs) => LocalizedString} */
const bn_portalnotify_error_body = en_portalnotify_error_body;

/**
* | output |
* | --- |
* | "Check your connection, then try again." |
*
* @param {Portalnotify_Error_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_error_body = /** @type {((inputs?: Portalnotify_Error_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_Error_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_error_body(inputs)
	if (locale === "he") return he_portalnotify_error_body(inputs)
	if (locale === "ur") return ur_portalnotify_error_body(inputs)
	if (locale === "es") return es_portalnotify_error_body(inputs)
	if (locale === "fr") return fr_portalnotify_error_body(inputs)
	if (locale === "de") return de_portalnotify_error_body(inputs)
	if (locale === "pt") return pt_portalnotify_error_body(inputs)
	if (locale === "hi") return hi_portalnotify_error_body(inputs)
	if (locale === "bn") return bn_portalnotify_error_body(inputs)
	return /** @type {LocalizedString} */ ("Check your connection, then try again.")
});